module.exports = __webpack_public_path__ + "img/t3-c4.8969001d.png";